import {
  filterPermittedActionsWithDividers,
  parseActionsOnValidDivider,
} from '../../utils/massActions'
import {
  isSubAll,
  isSubArchive,
  isSubRead,
  isSubUnread,
} from '../../utils/route'

import {
  REQUEST_ACTION_ARCHIVE_MASS,
  REQUEST_ACTION_ASSIGN_MASS,
  REQUEST_ACTION_CONNECT_DOC_FLOW_MASS,
  REQUEST_ACTION_CONNECT_SERVICE_REQUEST_MASS,
  REQUEST_ACTION_CREATE_DOC_FLOW_MASS,
  REQUEST_ACTION_DUE_DATE_MASS,
  REQUEST_ACTION_EDIT_CATEGORY_MASS,
  REQUEST_ACTION_EDIT_LABEL_MASS,
  REQUEST_ACTION_EDIT_PROVIDER_MASS,
  REQUEST_ACTION_GROUP_SERVICE_REQUESTS_MASS,
  REQUEST_ACTION_MARK_AS_PRIVATE_MASS,
  REQUEST_ACTION_MARK_AS_PUBLIC_MASS,
  REQUEST_ACTION_MARK_AS_READ_MASS,
  REQUEST_ACTION_MARK_AS_UNREAD_MASS,
  REQUEST_ACTION_RESTORE_MASS,
  REQUEST_ACTION_UPDATE_STATUS_MASS,
} from './Request.constants.actions'
import { isRequestArchived } from './Request.utils'

function getRequestMassActionsArchiveState({ selectAllPages, selected, sub }) {
  const archivedCount = selected.filter(isRequestArchived).length
  const hasArchivedAndActive =
    archivedCount > 0 && archivedCount < selected.length

  const isMixed = isSubAll(sub) && (selectAllPages || hasArchivedAndActive)

  return {
    isArchive: isSubAll(sub)
      ? !isMixed && archivedCount > 0
      : isSubArchive(sub),
    isMixed,
  }
}

export function isRequestSelectionWithArchived({
  selectAllPages,
  selected,
  sub,
}) {
  const { isArchive, isMixed } = getRequestMassActionsArchiveState({
    selectAllPages,
    selected,
    sub,
  })

  return isArchive || isMixed
}

export function getMassActions({
  canCreateDocFlow,
  permissions,
  selectAllPages,
  selected,
  sub,
  t,
}) {
  const { isArchive, isMixed } = getRequestMassActionsArchiveState({
    selectAllPages,
    selected,
    sub,
  })

  const isEditable = !isArchive && !isMixed

  const items = [
    {
      label: t('Request.EditAssigneeActionOptionKey'),
      permission: permissions.can_edit_assignee && isEditable,
      value: REQUEST_ACTION_ASSIGN_MASS,
    },
    {
      label: t('Request.EditProviderActionOptionKey'),
      permission: permissions.can_edit_contractors && isEditable,
      value: REQUEST_ACTION_EDIT_PROVIDER_MASS,
    },
    {
      label: t('Request.ChangeStatusActionOptionKey'),
      permission: permissions.can_edit_status && isEditable,
      value: REQUEST_ACTION_UPDATE_STATUS_MASS,
    },
    {
      label: t('Request.ChangeDeadlineActionOptionKey'),
      permission: permissions.can_edit_due_date && isEditable,
      value: REQUEST_ACTION_DUE_DATE_MASS,
    },
    {
      label: t('Request.EditLabelActionOptionKey'),
      permission: permissions.can_edit_labels && isEditable,
      value: REQUEST_ACTION_EDIT_LABEL_MASS,
    },
    {
      label: t('Request.EditCategoryActionOptionKey'),
      permission: permissions.can_edit_category && isEditable,
      value: REQUEST_ACTION_EDIT_CATEGORY_MASS,
    },
    {
      label: t('Request.ConnectServiceRequestsActionOptionKey'),
      permission: permissions.can_add_connected_requests && isEditable,
      value: REQUEST_ACTION_CONNECT_SERVICE_REQUEST_MASS,
    },
    {
      disabled: selectAllPages,
      label: t('Request.ConnectDocFlowActionOptionKey'),
      permission: permissions.can_add_connected_requests,
      value: REQUEST_ACTION_CONNECT_DOC_FLOW_MASS,
    },
    {
      label: t('Request.CreateDocFlowActionOptionKey'),
      permission: permissions.can_add_connected_requests && canCreateDocFlow,
      value: REQUEST_ACTION_CREATE_DOC_FLOW_MASS,
    },
    {
      disabled: selected.length === 1,
      label: t('Request.AttachToEachOtherMassActionOptionKey'),
      permission: permissions.can_group_requests,
      value: REQUEST_ACTION_GROUP_SERVICE_REQUESTS_MASS,
    },
    {
      label: t('Request.MarkAsUnreadActionOptionKey'),
      permission:
        permissions.can_edit_unread_status && isEditable && !isSubUnread(sub),
      value: REQUEST_ACTION_MARK_AS_UNREAD_MASS,
    },
    {
      label: t('Request.MarkAsReadActionOptionKey'),
      permission:
        permissions.can_edit_unread_status && isEditable && !isSubRead(sub),
      value: REQUEST_ACTION_MARK_AS_READ_MASS,
    },
    {
      label: t('Request.MarkAsPublicActionOptionKey'),
      permission: permissions.can_edit_visibility_to_dwellers && isEditable,
      value: REQUEST_ACTION_MARK_AS_PUBLIC_MASS,
    },
    {
      label: t('Request.MarkAsPrivateActionOptionKey'),
      permission: permissions.can_edit_visibility_to_dwellers && isEditable,
      value: REQUEST_ACTION_MARK_AS_PRIVATE_MASS,
    },
    null,
    {
      disabled: isMixed,
      label: t('Request.ArchiveActionOptionKey'),
      permission: permissions.can_archive && !isArchive,
      tooltipContent: isMixed
        ? t('Request.MassArchiveMixedSelectionTooltipKey')
        : null,
      value: REQUEST_ACTION_ARCHIVE_MASS,
    },
    {
      disabled: isMixed,
      label: t('Request.RestoreActionOptionKey'),
      permission: permissions.can_restore && (isArchive || isMixed),
      tooltipContent: isMixed
        ? t('Request.MassRestoreMixedSelectionTooltipKey')
        : null,
      value: REQUEST_ACTION_RESTORE_MASS,
    },
  ]

  return parseActionsOnValidDivider(filterPermittedActionsWithDividers(items))
}
